module.exports = __webpack_public_path__ + "why2.png?d448c9ddd114534546b800638be40d65";